import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { GRAPH, msalConfig } from './configuration';
import { StorageUtils } from '@/components/ms-teams/StorageUtils';

let msalInstance = null;
export const getMSALInstance = () => msalInstance;
export const getUsername = () => username;

let username = '';

const initializeMSAL = callback => {
  msalInstance = new PublicClientApplication(msalConfig);
  msalInstance.addEventCallback(event => {
    switch (event.eventType) {
      case EventType.LOGIN_SUCCESS:
      case EventType.ACQUIRE_TOKEN_SUCCESS:
        if (event.payload.account) {
          const account = event.payload.account;
          msalInstance.setActiveAccount(account);
        }
        break;
      case EventType.LOGOUT_SUCCESS:
        if (msalInstance.getAllAccounts().length > 0) {
          msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
        }
        break;
    }
  });
  callback && callback();
};

const signIn = () => {
  return msalInstance
    .loginPopup({
      scopes: [GRAPH.SCOPES.USER_READ, GRAPH.SCOPES.PRESENCE_READ, GRAPH.SCOPES.SUBSCRIPTION_READ]
    })
    .then(handleResponse)
    .catch(console.error);
};

const signOut = () => {
  const account = msalInstance.getAccountByUsername(username);
  const logoutRequest = {
    account,
    mainWindowRedirectUri: '/'
  };
  StorageUtils.clear(account);
  return msalInstance.logoutPopup(logoutRequest).catch(console.error);
};

const handleResponse = response => {
  if (response !== null) {
    username = response.account.username;
  }
};

const setConfiguration = (msTeamsConfiguration, callback) => {
  if (
    !msTeamsConfiguration ||
    !msTeamsConfiguration.applicationId ||
    !msTeamsConfiguration.tenantId ||
    !msTeamsConfiguration.redirectUrl
  ) {
    const errorMessage = 'Invalid MS Teams configuration';
    console.error(`${errorMessage}, please set the configuration at ECS Web Admin`, msTeamsConfiguration);
    throw new Error(errorMessage);
  }

  msalConfig.auth.clientId = msTeamsConfiguration.applicationId;
  msalConfig.auth.authority = `https://login.microsoftonline.com/${msTeamsConfiguration.tenantId}`;
  msalConfig.auth.redirectUri = msTeamsConfiguration.redirectUrl;

  initializeMSAL(callback);
};

export const msalActions = {
  signIn,
  signOut,
  setConfiguration
};
